import React, { useMemo } from "react";
import { Form, Input, Table, Select } from "antd";
import { Controller } from "react-hook-form";
import { MinusCircleOutlined } from "@ant-design/icons";

import { EPrimarySubmissionMethod, EReportType } from "../../../utils/types";
import { useGetPMS } from "../../../hooks/pms.hooks";

const { Option } = Select;

const BulkPMSReportCreationTable = ({
  dataSource,
  errors,
  control,
  remove,
}) => {
  const { data: pmsData } = useGetPMS();

  const reportTypeOptions = () => {
    return Object.keys(EReportType).map((key) => (
      <Option key={EReportType[key]} value={EReportType[key]}>
        {EReportType[key]}
      </Option>
    ));
  };

  const sourceTypeOptions = () => {
    return Object.keys(EPrimarySubmissionMethod).map((key) => (
      <Option
        key={EPrimarySubmissionMethod[key]}
        value={EPrimarySubmissionMethod[key]}
      >
        {EPrimarySubmissionMethod[key]}
      </Option>
    ));
  };

  const pmsOptions = useMemo(() => {
    return pmsData?.map((data) => (
      <Option key={data._id} value={data._id}>
        {data.pms_name}
      </Option>
    ));
  }, [pmsData]);

  const columns = [
    {
      title: "PMS",
      dataIndex: "pms",
      key: "pms",
      width: "175px",
      render: (_text, _record, index) => (
        <Form.Item
          validateStatus={errors?.formData?.[index]?.pms ? "error" : ""}
        >
          <Controller
            render={({ field }) => (
              <Select
                {...field}
                showSearch
                optionFilterProp="children"
                notFoundContent={null}
              >
                {pmsOptions}
              </Select>
            )}
            name={`formData.${index}.pms`}
            control={control}
          />
        </Form.Item>
      ),
    },
    {
      title: "myDocs Report Name",
      dataIndex: "mydocs_report_name",
      key: "mydocs_report_name",
      width: "250px",
      render: (_text, _record, index) => (
        <Form.Item
          validateStatus={
            errors?.formData?.[index]?.mydocs_report_name ? "error" : ""
          }
        >
          <Controller
            render={({ field }) => <Input {...field} />}
            name={`formData.${index}.mydocs_report_name`}
            control={control}
          />
        </Form.Item>
      ),
    },
    {
      title: "PMS Report Name",
      dataIndex: "report_name",
      key: "report_name",
      width: "250px",
      render: (_text, _record, index) => (
        <Form.Item
          validateStatus={errors?.formData?.[index]?.report_name ? "error" : ""}
        >
          <Controller
            render={({ field }) => <Input {...field} />}
            name={`formData.${index}.report_name`}
            control={control}
          />
        </Form.Item>
      ),
    },
    {
      title: "Report Code/Spooler Code",
      dataIndex: "report_code",
      key: "report_code",
      width: "200px",
      render: (_text, _record, index) => (
        <Form.Item
          validateStatus={errors?.formData?.[index]?.report_code ? "error" : ""}
        >
          <Controller
            render={({ field }) => <Input {...field} />}
            name={`formData.${index}.report_code`}
            control={control}
          />
        </Form.Item>
      ),
    },
    {
      title: "Primary Submission Method",
      dataIndex: "source_type",
      key: "source_type",
      width: "200px",
      render: (_text, _record, index) => (
        <Form.Item
          validateStatus={errors?.formData?.[index]?.source_type ? "error" : ""}
        >
          <Controller
            render={({ field }) => (
              <Select
                {...field}
                showSearch
                optionFilterProp="children"
                notFoundContent={null}
              >
                {sourceTypeOptions()}
              </Select>
            )}
            name={`formData.${index}.source_type`}
            control={control}
          />
        </Form.Item>
      ),
    },
    {
      title: "myDocs Report Type",
      dataIndex: "mydocs_report_type",
      key: "mydocs_report_type",
      width: "150px",
      render: (_text, _record, index) => (
        <Form.Item
          validateStatus={
            errors?.formData?.[index]?.mydocs_report_type ? "error" : ""
          }
        >
          <Controller
            render={({ field }) => (
              <Select
                {...field}
                showSearch
                optionFilterProp="children"
                notFoundContent={null}
              >
                {reportTypeOptions()}
              </Select>
            )}
            name={`formData.${index}.mydocs_report_type`}
            control={control}
          />
        </Form.Item>
      ),
    },
    {
      title: "File Name",
      dataIndex: "file_name",
      key: "file_name",
      width: "250px",
      render: (_text, _record, index) => (
        <Form.Item
          validateStatus={errors?.formData?.[index]?.file_name ? "error" : ""}
        >
          <Controller
            render={({ field }) => <Input {...field} />}
            name={`formData.${index}.file_name`}
            control={control}
          />
        </Form.Item>
      ),
    },
    {
      title: "Remove",
      dataIndex: "operation",
      width: "80px",
      fixed: "right",
      align: "center",
      render: (_text, record, index) => (
        <MinusCircleOutlined
          className="dynamic-delete-button"
          style={{ margin: "0 8px" }}
          onClick={() => remove(index)}
        />
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      size="small"
      rowKey="id"
      pagination={false}
      scroll={{ x: 1950 }}
    />
  );
};

export default BulkPMSReportCreationTable;
